import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import styled from 'styled-components';
import User from './User';
import ProductsHover from './ProductsHover';
import DevelopersHover from './DevelopersHover';
import CompanyHover from './CompanyHover';
import { ChevronRight, ChevronUp, ChevronDown, Menu, X, ArrowLeft } from 'lucide-react';
import { prefetchRoute } from '@/lib/prefetch';

const StyledNav = styled.nav<{ $scrolled: boolean }>`

@keyframes spinThreeOvershoot {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(180deg);
  }

}


  position: ${({ $scrolled }) => ($scrolled ? 'fixed' : 'absolute')};
  top: 0;
  left: 0;
  z-index: 900;
  display: flex;
  width: calc(100% - 80px);
  justify-content: space-between;
  align-items: center;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  margin: ${({ $scrolled }) => ($scrolled ? '0' : '10px 20px')};
  padding: ${({ $scrolled }) => ($scrolled ? '8px 40px' : '0 20px')};
  justify-content: space-between;
  background-color: ${({ $scrolled }) => ($scrolled ? 'rgba(var(--whiter), 0.9)' : 'transparent')};
  box-shadow: ${({ $scrolled }) => ($scrolled ? '0 1px 8px rgba(0,0,0,0.01)' : 'none')};
  backdrop-filter : ${({ $scrolled }) => ($scrolled ? 'blur(5px)' : 'unset')};
  transition: all 0.3s ease-in-out;

  @media (max-width: 968px) {
    width: calc(100% - 50px);
    margin: 10px;
    padding: 15px;
    border-radius: 5px;
  }

  @media (max-width: 400px) {
    width: calc(100% - 42px);
    margin: 8px;
    padding: 12px;
  }

  .logo {
    cursor: pointer;
    display: flex;
    align-items: center;

    .spin{
      transform-origin: center;
    }

    .logo-icon {
      position: relative;
      width: 30px;
      height: 30px;
      transition: all 0.2s ease-in-out;

      @media (max-width: 968px) {
        width: 24px;
        height: 24px;
      }

      @media (max-width: 400px) {
        width: 22px;
        height: 22px;
      }

      svg {
        width: auto;
        height: 100%;
        pointer-events: none;
        user-select: none;
        opacity: 1;
        transition: opacity 0.2s ease-in-out;

        @media (max-width: 968px) {
          height: 100%;
        }
      }

      .back-arrow {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.2s ease-in-out;

        svg {
          width: 24px;
          height: 24px;
        }
      }
    }

    &:hover .logo-icon {
      transform: translateX(-2px) scale(1.02);
      opacity: 0.8;
    }

    &:hover .logo-icon svg.logo-svg {
      opacity: 0;
    }

    &:hover .logo-icon .back-arrow {
      opacity: 1;
    }

    span {
      transition: opacity 0.2s ease-in-out;
    }

    &:hover span {
      opacity: 0.8;
    }

    &.home:hover .logo-icon {
      transform: scale(1.025);
      opacity: 1;
    }

    &.home:hover .logo-icon svg.logo-svg {
      opacity: 0.7;
    }

    &.home:hover .logo-icon .back-arrow {
      opacity: 0;
    }
  }

  .mobile-menu-toggle {
    display: none;
    cursor: pointer;
    padding: 5px;
    z-index: 999;
    top: ${({ $scrolled }) => ($scrolled ? '10px' : '20px')};
    right: ${({ $scrolled }) => ($scrolled ? '10px' : '20px')};

    &.open{
      position: fixed;
      background: white;
      border-radius: 8px;
      box-shadow: 0px 0px 1px 1px rgba(var(--greyr), 0.08);
    }


    @media (max-width: 968px) {
      display: block;
    }
  }

  .auth a.hover{
    padding: 10px 15px;
    transition: all 0.3s ease-in-out;
    border-radius: 6px;
  }
  .auth .user {
    display: flex;
    align-items: center;
    gap: 30px;

    @media (max-width: 968px) {
      gap: 15px;
    }

    > a {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0;
      gap: 5px;
      padding: 10px;
      @media (max-width: 968px) {
        font-size: 14px;
      }
    }
  }

  @media (max-width: 968px) {
    .hover{
      background-color: white!important;
    }
  }
  .links {
    display: flex;
    //gap: 20px;

    @media (max-width: 968px) {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      background-color: rgba(var(--whiter), 1);
      flex-direction: column;
      gap: 0;
      padding: 20px 20px 20px;
      transform: translateX(-150%);
      transition: transform 0.3s ease-in-out;
      overflow-y: auto;

      &.open {
        transform: translateX(0);
        top: ${({ $scrolled }) => ($scrolled ? '-10px' : '0')};
        left: ${({ $scrolled }) => ($scrolled ? '-10px' : '0')};
      }
    }

    @media (max-width: 400px) {
      padding: 20px 16px 16px;
    }

    .link-container {
      position: relative;
      padding: 20px 15px;
      margin: 0 5px;
      cursor: pointer;
      .chev, .desktop-chev{
        padding: 0 6px;
      }

      .chev{
        transition: transform 0.3s ease;
        transform-origin: center;
        display: none;
      }

      &.mobile-open{
        .chev{
          transform: rotate(180deg);
        }

      }
      @media (max-width: 968px) {
        width: 100%;
        margin: 0;
        padding: 0;
        border-bottom: 1px solid rgba(var(--greyr), 0.1);
        .desktop-chev{
          display: none;
        }
        .chev{
          display: unset;
        }
      }

       &:hover {
        a{
            transition-duration: 0.3s;
            &:after {
              opacity: 1;
              transition-duration: 0.3s;
            }
          }

        }
    }

    a, button {
      position: relative;
      transition: all 0.3s ease-in-out;

      @media (max-width: 968px) {
        display: block;
        padding: 20px 0;
        font-size: 18px;
        padding-left: 0 !important;
      }

      @media (max-width: 400px) {
        padding: 16px 0;
        font-size: 16px;
      }

      &:after {
        content: "";
        transition-duration: 0.3s;
        position: absolute;
        display: block;
        width: 100%;
        height: 2px;
        bottom: -15px;
        left: 0;
        background: rgba(var(--greyr), 0.3);
        opacity: 0;

        @media (max-width: 968px) {
          display: none;
        }
      }

    }

    > a {
      @media (max-width: 968px) {
        border-bottom: 1px solid rgba(var(--greyr), 0.1);
      }
    }
  }

  .auth {
    @media (max-width: 968px) {
      display: none;

      &.mobile {
        display: block;
        position: fixed;
        top: 70px;
        right: 20px;
      }
    }
  }
`;

const DropdownContainer = styled.div<{ $left: number }>`
  position: absolute;
  top: 52px;
  left: ${({ $left }) => $left}px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-in-out;
  pointer-events: none;

  &.active {
    opacity: 1;
    visibility: visible;
    pointer-events: all;
  }

  @media (max-width: 968px) {
    position: static;
    opacity: 1;
    visibility: visible;
    padding-left: 0px;
    margin-top: 0px;
    overflow: hidden;
    transition: max-height 0.35s ease, opacity 0.3s ease;

    &.mobile-hidden {
      max-height: 0;
      opacity: 0;
      pointer-events: none;
    }

    &.mobile-visible {
      // max-height: 1180px;
      opacity: 1;
      pointer-events: all;
    }
  }
`;

const MobileAuthSection = styled.div`
  display: none;

  @media (max-width: 968px) {
    display: block;
    padding: 20px 0;
    margin-top: 20px;

    a {
      display: block;
      padding: 15px 0;
      font-size: 18px;
    }

    .user {
      width: ${({ $scrolled }) => ($scrolled ? 'calc(100% - 20px)' : 'calc(100% - 40px)')};
      display: flex;
      flex-direction: row-reverse;
      align-items: flex-start;
      justify-content: space-between;
      height: 440px;

      > a {
        padding: 15px 0;
      }
    }
  }
`;

const DEFAULT_LEFT = -360;
const DROPDOWN_WIDTH = 700;
const VIEWPORT_MARGIN = 10;

const calcDropdownLeft = (
  containerRef: React.RefObject<HTMLDivElement>,
  dropdownWidth = DROPDOWN_WIDTH,
  defaultLeft = DEFAULT_LEFT
): number => {
  if (!containerRef.current) return defaultLeft;
  const rect = containerRef.current.getBoundingClientRect();
  const absLeft = rect.left + defaultLeft;
  const absRight = absLeft + dropdownWidth;

  if (absLeft < VIEWPORT_MARGIN) return -rect.left + VIEWPORT_MARGIN;
  if (absRight > window.innerWidth - VIEWPORT_MARGIN) return defaultLeft - (absRight - window.innerWidth + VIEWPORT_MARGIN);
  return defaultLeft;
};

const AppNavbar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useAuth();

  const [productsHover, setProductsHover] = useState(false);
  const [developersHover, setDevelopersHover] = useState(false);
  const [companyHover, setCompanyHover] = useState(false);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
  const [mobileDevelopersOpen, setMobileDevelopersOpen] = useState(false);
  const [mobileCompanyOpen, setMobileCompanyOpen] = useState(false);

  const [scrolled, setScrolled] = useState(
    () => typeof window !== 'undefined' && window.scrollY > 10
  );
  const [isTouch, setIsTouch] = useState(false);

  const companyRef = useRef<HTMLDivElement>(null);
  const productsRef = useRef<HTMLDivElement>(null);
  const developersRef = useRef<HTMLDivElement>(null);

  const [companyLeft, setCompanyLeft] = useState(DEFAULT_LEFT);
  const [productsLeft, setProductsLeft] = useState(DEFAULT_LEFT);
  const [developersLeft, setDevelopersLeft] = useState(DEFAULT_LEFT);

  const closeTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const openTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const cancelClose = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
  };

  const cancelOpen = () => {
    if (openTimeoutRef.current) {
      clearTimeout(openTimeoutRef.current);
      openTimeoutRef.current = null;
    }
  };

  const delayedClose = () => {
    cancelClose();
    closeTimeoutRef.current = setTimeout(() => {
      closeAllDesktopDropdowns();
      closeTimeoutRef.current = null;
    }, 200);
  };

  const openWithDelay = (dropdown: 'company' | 'products' | 'developers') => {
    cancelOpen();
    openTimeoutRef.current = setTimeout(() => {
      closeAllDesktopDropdowns();
      if (dropdown === 'company') {
        setCompanyLeft(calcDropdownLeft(companyRef));
        setCompanyHover(true);
      } else if (dropdown === 'products') {
        setProductsLeft(calcDropdownLeft(productsRef));
        setProductsHover(true);
      } else {
        setDevelopersLeft(calcDropdownLeft(developersRef));
        setDevelopersHover(true);
      }
      openTimeoutRef.current = null;
    }, 100);
  };

  useEffect(() => {
    setIsTouch('ontouchstart' in window || navigator.maxTouchPoints > 0);
  }, []);

  useEffect(() => {
    return () => {
      if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
      if (openTimeoutRef.current) clearTimeout(openTimeoutRef.current);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close nav on route change
  useEffect(() => {
    closeMobileMenu()
    setMobileProductsOpen(false);
    setMobileDevelopersOpen(false);
    setMobileCompanyOpen(false);
    closeAllDesktopDropdowns();
  }, [location.pathname]);

  // Close touch dropdowns when tapping outside
  useEffect(() => {
    if (!isTouch) return;
    const handleOutsideClick = (e: MouseEvent | TouchEvent) => {
      const target = e.target as Node;
      if (
        !companyRef.current?.contains(target) &&
        !productsRef.current?.contains(target) &&
        !developersRef.current?.contains(target)
      ) {
        setCompanyHover(false);
        setProductsHover(false);
        setDevelopersHover(false);
      }
    };
    document.addEventListener('touchstart', handleOutsideClick);
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('touchstart', handleOutsideClick);
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isTouch]);

  const closeAllDesktopDropdowns = () => {
    setCompanyHover(false);
    setProductsHover(false);
    setDevelopersHover(false);
  };

  const handleLogoClick = () => {
    if (location.pathname === '/') {
      closeMobileMenu()
      closeAllDesktopDropdowns();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    navigate('/');
    closeMobileMenu()
  };

  const handleLinkClick = (targetPath?: string) => {
    closeMobileMenu()
    if (targetPath) {
      const current = location.pathname.replace(/\/$/, '');
      const target = targetPath.replace(/\/$/, '');
      if (current === target) {
        closeAllDesktopDropdowns();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  const goTo = (e: React.MouseEvent, url: string) => {
    const path = `/${url}`;
    const current = location.pathname.replace(/\/$/, '');
    if (current === path) {
      e.stopPropagation();
      e.preventDefault();
      closeMobileMenu()
      closeAllDesktopDropdowns();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    navigate(path);
    handleLinkClick();
  };

  const handleNavClick = (e: React.MouseEvent) => {
    const link = (e.target as HTMLElement).closest('a');
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href) return;

    const current = location.pathname.replace(/\/$/, '');
    const target = href.replace(/\/$/, '');
    if (current === target && current !== '') {
      e.preventDefault();
      closeMobileMenu()
      closeAllDesktopDropdowns();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // For touch+desktop: first tap opens dropdown, second tap navigates
  const handleTouchDesktopClick = (
    e: React.MouseEvent,
    isOpen: boolean,
    openFn: () => void,
    navigateTo: string
  ) => {
    if (!isOpen) {
      e.preventDefault();
      closeAllDesktopDropdowns();
      openFn();
    } else {
      closeAllDesktopDropdowns();
      const current = location.pathname.replace(/\/$/, '');
      const target = navigateTo.replace(/\/$/, '');
      if (current === target) {
        closeMobileMenu()
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      navigate(navigateTo);
      handleLinkClick();
    }
  };

  const handleContainerClick = (
    e: React.MouseEvent,
    path: string,
    mobileOpen: boolean,
    setMobileOpen: (v: boolean) => void,
    hoverState: boolean,
    setHoverState: (v: boolean) => void,
    setLeft: (v: number) => void,
    ref: React.RefObject<HTMLDivElement>,
  ) => {
    if ((e.target as HTMLElement).closest('a')) return;

    if (isMobile()) {
      setMobileOpen(!mobileOpen);
    } else if (isTouch) {
      if (!hoverState) {
        closeAllDesktopDropdowns();
        setLeft(calcDropdownLeft(ref));
        setHoverState(true);
      } else {
        closeAllDesktopDropdowns();
        const current = location.pathname.replace(/\/$/, '');
        const target = path.replace(/\/$/, '');
        if (current === target) {
          closeMobileMenu()
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
        navigate(path);
        handleLinkClick();
      }
    } else {
      handleLinkClick(path);
      navigate(path);
    }
  };

  const closeMobileMenu = function(){
    document.body.style.overflow = '';
    document.documentElement.style.overflowY = '';
    setMobileMenuOpen(false);
  }

  const toggleMobileMenu = function(){
    if(!mobileMenuOpen){
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflowY = 'hidden';
      setMobileMenuOpen(true)
    }else{
      closeMobileMenu()
    }
  }


  const isMobile = () => window.innerWidth <= 968;

  return (
    <StyledNav $scrolled={scrolled} className={`${mobileMenuOpen ? 'op' : ''}`} onClick={handleNavClick}>
      <div className={`logo ${location.pathname === '/' ? 'home' : ''}`} onClick={handleLogoClick}>
        <div className="logo-icon">
          <svg className="logo-svg" xmlns="http://www.w3.org/2000/svg" width="126" height="126" viewBox="0 0 126 126" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M64.9362 23.0391C63.6566 22.799 62.3434 22.799 61.0638 23.0391C59.7888 23.2783 58.4825 23.8784 54.0781 26.0807L37.2781 34.4807C31.881 37.1792 30.3331 38.0297 29.2486 39.137C28.1596 40.2489 27.3314 41.589 26.8239 43.0603C26.3185 44.5255 26.25 46.2903 26.25 52.3245V70.033C26.25 75.4705 26.3068 77.0586 26.7304 78.4103C27.1556 79.7672 27.8519 81.0235 28.7772 82.1032C29.6989 83.1788 31.0155 84.0687 35.6265 86.9506L52.4265 97.4506C57.5984 100.683 59.1482 101.569 60.6734 101.916C62.2049 102.264 63.7951 102.264 65.3266 101.916C66.8518 101.569 68.4016 100.683 73.5735 97.4506L90.3735 86.9506C94.9845 84.0687 96.3011 83.1788 97.2228 82.1032C98.1481 81.0235 98.8444 79.7672 99.2696 78.4103C99.6932 77.0586 99.75 75.4705 99.75 70.033V52.3245C99.75 46.2903 99.6815 44.5255 99.1761 43.0603C98.6686 41.589 97.8404 40.2489 96.7514 39.137C95.6669 38.0297 94.119 37.1792 88.7219 34.4807L71.9219 26.0807C67.5175 23.8784 66.2112 23.2783 64.9362 23.0391ZM59.1276 12.7192C61.6869 12.239 64.3131 12.239 66.8724 12.7192C69.7769 13.2641 72.4711 14.6131 76.0396 16.3999C76.2297 16.4951 76.4224 16.5915 76.6177 16.6892L93.4177 25.0892C93.6595 25.2101 93.8982 25.3292 94.1338 25.4468C98.4915 27.622 101.777 29.2618 104.253 31.79C106.431 34.0138 108.087 36.6939 109.102 39.6366C110.256 42.9819 110.254 46.6536 110.25 51.524C110.25 51.7873 110.25 52.0541 110.25 52.3245V70.033C110.25 70.2752 110.25 70.5142 110.25 70.7501C110.253 75.1488 110.255 78.4677 109.289 81.5499C108.439 84.2637 107.046 86.7764 105.196 88.9358C103.094 91.3884 100.278 93.1457 96.5468 95.4747C96.3467 95.5996 96.1439 95.7261 95.9385 95.8545L79.1385 106.355C78.9065 106.499 78.6778 106.643 78.4521 106.784C74.2806 109.395 71.136 111.363 67.6533 112.155C64.5901 112.851 61.4099 112.851 58.3467 112.155C54.864 111.363 51.7195 109.395 47.5479 106.784C47.3222 106.643 47.0935 106.499 46.8615 106.355L30.0615 95.8545C29.8561 95.7261 29.6533 95.5996 29.4532 95.4747C25.722 93.1457 22.906 91.3884 20.8042 88.9358C18.9543 86.7764 17.5613 84.2637 16.7109 81.5499C15.7454 78.4677 15.7472 75.1488 15.75 70.7501C15.75 70.5142 15.75 70.2752 15.75 70.033V52.3245C15.75 46.6536 15.748 42.9819 16.9024 39.6366C17.9174 36.6939 19.5727 34.0138 21.7508 31.79C24.2266 29.2618 27.5122 27.622 31.8699 25.4468C32.1055 25.3292 32.3442 25.2101 32.586 25.0892L49.386 16.6892C49.5813 16.5915 49.774 16.4951 49.9641 16.3999C53.5326 14.6131 56.2268 13.2641 59.1313 12.7192H59.1276Z" fill="black"/><path fillRule="evenodd" clipRule="evenodd" d="M23.3479 32.0543L44.3479 42.5543L39.6521 51.9458L18.6521 41.4458L23.3479 32.0543ZM81.6521 42.5543L102.652 32.0543L107.348 41.4458L86.3479 51.9458L81.6521 42.5543ZM57.75 105V89.25H68.25V105H57.75Z" fill="black"/><path className="spin" fillRule="evenodd" clipRule="evenodd" d="M56.5722 56.5722L60.0117 46.2539H65.9884L69.4278 56.5722L79.7461 60.0117V65.9884L69.4278 69.4278L65.9884 79.7461H60.0117L56.5722 69.4278L46.2539 65.9884V60.0117L56.5722 56.5722Z" fill="black" /></svg>
          <div className="back-arrow">
            <ArrowLeft strokeWidth={2.5} />
          </div>
        </div>
      </div>

      <div className={`mobile-menu-toggle ${mobileMenuOpen ? 'open' : ''}`} onClick={() => toggleMobileMenu()}>
        {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </div>

      <div className={`links ${mobileMenuOpen ? 'open' : ''}`}>
        <div
          className={`link-container ${mobileCompanyOpen ? 'mobile-open' : ''}`}
          ref={companyRef}
          onMouseEnter={() => {
            if (isTouch) return;
            cancelClose();
            openWithDelay('company');
          }}
          onMouseLeave={() => {
            if (isTouch) return;
            cancelOpen();
            delayedClose();
          }}
          onClick={(e) => handleContainerClick(e, '/about', mobileCompanyOpen, setMobileCompanyOpen, companyHover, setCompanyHover, setCompanyLeft, companyRef)}
        >
          <Link
            to="/about"
            onMouseEnter={() => prefetchRoute('/about')}
            onClick={(e) => {
              e.stopPropagation();
              if (isMobile()) {
                e.preventDefault();
                setMobileCompanyOpen(!mobileCompanyOpen);
              } else if (isTouch) {
                handleTouchDesktopClick(e, companyHover, () => {
                  setCompanyLeft(calcDropdownLeft(companyRef));
                  setCompanyHover(true);
                }, '/about');
              } else {
                handleLinkClick('/about');
              }
            }}
          >
            Company
            <ChevronUp width={12} height={12} className="chev"/>
            <ChevronDown width={12} height={12} className="desktop-chev"/>
          </Link>

          <DropdownContainer
            $left={companyLeft}
            className={`${companyHover ? 'active' : ''} ${mobileCompanyOpen ? 'mobile-visible' : 'mobile-hidden'}`}
            onMouseEnter={cancelClose}
          >
            <CompanyHover />
          </DropdownContainer>
        </div>

        <div
          className={`link-container ${mobileProductsOpen ? 'mobile-open' : ''}`}
          ref={productsRef}
          onMouseEnter={() => {
            if (isTouch) return;
            cancelClose();
            openWithDelay('products');
          }}
          onMouseLeave={() => {
            if (isTouch) return;
            cancelOpen();
            delayedClose();
          }}
          onClick={(e) => handleContainerClick(e, '/products', mobileProductsOpen, setMobileProductsOpen, productsHover, setProductsHover, setProductsLeft, productsRef)}
        >
          <Link
            to="/products"
            onMouseEnter={() => prefetchRoute('/products')}
            onClick={(e) => {
              e.stopPropagation();
              if (isMobile()) {
                e.preventDefault();
                setMobileProductsOpen(!mobileProductsOpen);
              } else if (isTouch) {
                handleTouchDesktopClick(e, productsHover, () => {
                  setProductsLeft(calcDropdownLeft(productsRef));
                  setProductsHover(true);
                }, '/products');
              } else {
                handleLinkClick('/products');
              }
            }}
          >
            Products
            <ChevronUp width={12} height={12} className="chev"/>
            <ChevronDown width={12} height={12} className="desktop-chev"/>
          </Link>
          <DropdownContainer
            $left={productsLeft}
            className={`${productsHover ? 'active' : ''} ${mobileProductsOpen ? 'mobile-visible' : 'mobile-hidden'}`}
            onMouseEnter={cancelClose}
          >
            <ProductsHover />
          </DropdownContainer>
        </div>

        <div
          className={`link-container ${mobileDevelopersOpen ? 'mobile-open' : ''}`}
          ref={developersRef}
          onMouseEnter={() => {
            if (isTouch) return;
            cancelClose();
            openWithDelay('developers');
          }}
          onMouseLeave={() => {
            if (isTouch) return;
            cancelOpen();
            delayedClose();
          }}
          onClick={(e) => handleContainerClick(e, '/developers', mobileDevelopersOpen, setMobileDevelopersOpen, developersHover, setDevelopersHover, setDevelopersLeft, developersRef)}
        >
          <Link
            to="/developers"
            onMouseEnter={() => prefetchRoute('/developers')}
            onClick={(e) => {
              e.stopPropagation();
              if (isMobile()) {
                e.preventDefault();
                setMobileDevelopersOpen(!mobileDevelopersOpen);
              } else if (isTouch) {
                handleTouchDesktopClick(e, developersHover, () => {
                  setDevelopersLeft(calcDropdownLeft(developersRef));
                  setDevelopersHover(true);
                }, '/developers');
              } else {
                handleLinkClick('/developers');
              }
            }}
          >
            Developers
            <ChevronUp width={12} height={12} className="chev"/>
            <ChevronDown width={12} height={12} className="desktop-chev"/>
          </Link>
          <DropdownContainer
            $left={developersLeft}
            className={`${developersHover ? 'active' : ''} ${mobileDevelopersOpen ? 'mobile-visible' : 'mobile-hidden'}`}
            onMouseEnter={cancelClose}
          >
            <DevelopersHover />
          </DropdownContainer>
        </div>

        <div className="link-container" onClick={(e) => goTo(e, 'pricing')}>
          <Link to="/pricing" className="link" onMouseEnter={() => prefetchRoute('/pricing')} onClick={() => handleLinkClick('/pricing')}>Pricing</Link>
        </div>

        <MobileAuthSection $scrolled={scrolled} >
          {!token ? (
            <Link to="/login" onMouseEnter={() => prefetchRoute('/login')} onClick={() => handleLinkClick('/login')} className="hover">● Get Started</Link>
          ) : (
            <div className="user">
              <Link to="/dashboard" onMouseEnter={() => prefetchRoute('/dashboard')} onClick={() => handleLinkClick('/dashboard')} className="hover">
                Dashboard <ChevronRight width={12} height={12} />
              </Link>
              <User inlineMobile={true} />
            </div>
          )}
        </MobileAuthSection>
      </div>

      <div className="auth">
        {!token ? (
          <Link to="/login" onMouseEnter={() => prefetchRoute('/login')} className="hover">● Get Started</Link>
        ) : (
          <div className="user">
            <Link to="/dashboard" onMouseEnter={() => prefetchRoute('/dashboard')} className="hover">Dashboard <ChevronRight width={12} height={12} /></Link>
            <User />
          </div>
        )}
      </div>
    </StyledNav>
  );
};

export default AppNavbar;
